import React, { useEffect, useState } from 'react';
import Select from 'react-select';
import { ListButton, Title, usePermissions, useResourceContext } from 'react-admin';
import { Papa } from '../common/common';
import { Typography, Box, Alert } from '@mui/material';
import { RUN_TIME_API_ENDPOINT, CommonHeaderOption } from '../common/common';
import Swal from 'sweetalert2';
import { useNavigate } from 'react-router-dom';

const UploadFile = (props) => {

    const navigate = useNavigate();
    const permissions = usePermissions();
    const resources = useResourceContext()

    const [showLoader, setShowLoader] = useState(false);
    const [successMsg, setSuccessMsg] = useState(false);
    const [validationTitleError, setValidationTitleError] = useState(false);
    const [saveButtonDisabled, setSaveButtonDisabled] = useState(true);
    const [errorMsg, setErrorMsg] = useState(false);
    const [errorMsgText, setErrorMsgText] = useState(null);
    const [type, setType] = useState('Country');
    const [saleOffNameSapCode, setSaleOffNameSapCode] = useState([]);
    const [parsedCSVdata, setParsedCSVdata] = useState([]);
    const [unregisteredRetailers, setUnregisteredRetailers] = useState([]);
    const [pasrsedSimilarDataLength, setPasrsedSimilarDataLength] = useState(0);
    const [pasrsedDifferentDataLength, setPasrsedDifferentDataLength] = useState(0);
    const [unregisteredRetailersToggle, setUnregisteredRetailersToggle] = useState(false);
    const [saleOffList, setSaleOffList] = useState([]);
    const [soSapCodeList, setSoSapCodeList] = useState([]);
    const [soList, setSoList] = useState([]);
    const [isSoListPresent, setIsSoListPresent] = useState(false);
    const [regionSapCodeList, setRegionSapCodeList] = useState([]);
    const [originalRegionList, setOriginalRegionList] = useState([]);
    const [regionList, setRegionList] = useState([]);
    const [isRegionListPresent, setIsRegionListPresent] = useState(false);
    const [customerGroupSapCodeList, setCustomerGroupSapCodeList] = useState([]);
    const [customerGroupList, setCustomerGroupList] = useState([]);
    const [iscustomerGroupListPresent, setIscustomerGroupListPresent] = useState(false);
    const [originalList, setOriginalList] = useState([]);
    const [inAppTitle, setInAppTitle] = useState('');
    const [originalSOList, setOriginalSOList] = useState([]);
    const [originalCustomerGroupList, setOriginalCustomerGroupList] = useState([]);
    const [fileUploaded, setFileUploaded] = useState(null);

    useEffect(() => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        fetch(`${apiUrl}/so_business_list`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                obj.loadingShow = false;
                setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
                setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
            });
    }, [])

    const handleChange = e => {
        const arr = [...originalList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalList];
            setSaleOffList([]);
        }
        setSaleOffList(e);
        setSaleOffNameSapCode(result);
    };

    const titleChange = (e) => {
        if (e.target.value === '' || e.target.value === undefined || e.target.value === null || !e.target.value.trim().length) {
            setValidationTitleError(true);
        } else {
            setValidationTitleError(false);
        }
        setInAppTitle(e.target.value)
    };

    // sales officer list
    const salesOfficerListCall = () => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        fetch(`${apiUrl}/get_sales_officers_by_country`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                if (jsonD.data) {
                    console.log('obj==>', obj);
                    setOriginalSOList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.email, 'label': item.username ? item.username + ' - ' + item.email : item.email })))
                    setSoSapCodeList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.email, 'label': item.username ? item.username + ' - ' + item.email : item.email })))
                }
            });
    }

    const salesOfficerRetailListCall = (soList) => {
        console.log('list of so', soList);
        const soIds = soList.map(e => e.id);
        const urlParams = encodeURIComponent(JSON.stringify(soIds));
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;

        options.method = 'GET';
        fetch(`${apiUrl}/businesses_list_for_salesofficers?ids=${urlParams}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
                setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
                setSaleOffList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
            });
    }

    const soRetailHandleChange = e => {
        const arr = [...originalList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalList];
            setSaleOffList([])
        }
        setSaleOffList(e);
        setSaleOffNameSapCode(result);
    }

    const soHandleChange = e => {
        const arr = [...originalSOList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalSOList];
            setSoList([])
            setIsSoListPresent(false);
            setSaleOffList([])
        } else {
            setIsSoListPresent(true);
        }

        setSoList(e);
        setSoSapCodeList(result);

        if (e !== null) {
            salesOfficerRetailListCall(e);
        }
    };

    const regionListCall = () => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        fetch(`${apiUrl}/list_of_regions`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                if (jsonD.data) {
                    console.log('obj==>', obj);
                    setOriginalRegionList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.name, 'label': item.name })))
                    setRegionSapCodeList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.name, 'label': item.name })))
                }
            });
    }

    const regionRetailListCall = (regionList) => {
        const regIds = regionList.map(e => e.id);
        const urlParams = encodeURIComponent(JSON.stringify(regIds));
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;

        options.method = 'GET';
        fetch(`${apiUrl}/get_business_by_region?region_ids=${urlParams}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
                setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
                setSaleOffList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
            });
    }

    const regionRetailHandleChange = e => {
        const arr = [...originalList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalList];
            setSaleOffList([]);
        }
        setSaleOffList(e);
        setSaleOffNameSapCode(result);
    }

    const regionHandleChange = e => {
        const arr = [...originalRegionList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalRegionList];
            setRegionList([]);
            setIsRegionListPresent(false);
            setSaleOffList([]);
        } else {
            setIsRegionListPresent(true);
        }
        setRegionList(e);
        setRegionSapCodeList(result)

        if (e !== null) {
            regionRetailListCall(e);
        }
    };

    // customer group list
    const customerGroupListCall = () => {
        const options = CommonHeaderOption();
        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        fetch(`${apiUrl}/customer_group_country`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                if (jsonD.data) {
                    console.log('obj==>', obj);
                    setOriginalCustomerGroupList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.code, 'label': item.description })));
                    setCustomerGroupSapCodeList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.code, 'label': item.description })));
                }
            });
    }

    const customerGroupRetailCall = (customerGroupList) => {
        const regIds = customerGroupList.map(e => e.value);
        const urlParams = encodeURIComponent(JSON.stringify(regIds));
        const options = CommonHeaderOption();

        const apiUrl = RUN_TIME_API_ENDPOINT;
        options.method = 'GET';
        fetch(`${apiUrl}/retailer_customer_group?code=${urlParams}`, options)
            .then(res => {
                return res.json();
            }).then(jsonD => {
                console.log('jsonD ===>', jsonD)
                let obj = {};
                obj.sap_order_materials = jsonD.data;
                setOriginalList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
                setSaleOffNameSapCode(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })));
                setSaleOffList(obj.sap_order_materials.map(item => ({ 'id': item.id, 'value': item.label, 'label': item.label, 'sap': item.sap_code.trim() })))
            });
    }

    const customerRetailerHandleChange = e => {
        const arr = [...originalList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalList];
            setSaleOffList([]);
        }
        setSaleOffList(e);
        setSaleOffNameSapCode(result);
    }

    const customerGroupHandleChange = e => {
        const arr = [...originalCustomerGroupList]

        let result = arr && arr.filter(item => e && e.filter(i => i.id === item.id).length === 0);
        if (e === null) {
            result = [...originalRegionList];
            setCustomerGroupList([]);
            setIscustomerGroupListPresent(false);
            setSaleOffList([]);
        } else {
            setIscustomerGroupListPresent(true);
        }
        setCustomerGroupList(e);
        setCustomerGroupSapCodeList(result);
        if (e !== null) {
            customerGroupRetailCall(e);
        }
    };

    const selectHandleChange = (event) => {
        setType(event.target.value)
        if (event.target.value === 'Sales') {
            console.log('salessss');
            setSaleOffList([]);
            setSoSapCodeList([]);
            setSoList([]);
            salesOfficerListCall();
        }

        if (event.target.value === 'Region') {
            setSaleOffList([]);
            setRegionSapCodeList([]);
            setRegionList([]);
            regionListCall();
        }

        if (event.target.value === 'customerGroup') {
            setSaleOffList([]);
            setCustomerGroupSapCodeList([]);
            setCustomerGroupList([])
            customerGroupListCall();
        }

        if (event.target.value === 'Country') {
            setSaleOffList([]);
            setCustomerGroupSapCodeList([]);
            setCustomerGroupList([])
            customerGroupListCall();
        }
    }

    const formSave = () => {
        const checkType = type === 'Sales' || type === 'Region' || type === 'customerGroup' ? 'Business' : type;

        if (checkType === 'Business' && saleOffList.length == 0) {
            return alert('Please choose atleast one retailer');
        };

        setShowLoader(true);
        setSaveButtonDisabled(false);


        const formData = new FormData();
        formData.append('name', inAppTitle.trim());
        formData.append('type', checkType)
        formData.append('sap_code', JSON.stringify(saleOffList))
        formData.append('file', fileUploaded)

        console.log("formData", formData, saleOffList, fileUploaded)

        const options = CommonHeaderOption();
        options.method = 'POST';

        const stateData = localStorage.getItem('__state');
        const userData = stateData ? JSON.parse(stateData) : false;
        options.headers = {
            'Authorization': userData._token,
        }
        options.body = formData;

        const url = `${RUN_TIME_API_ENDPOINT}/customer_file_downloads`;

        return fetch(url, options)
            .then(res => {
                console.log('fileUploadPDF Response', res)
                if (res) {
                    return res.json();
                }
            }
            )
            .then(res => {
                console.log('fileUploadPDF Response111', res)
                if (res.errorMsg) {
                    Swal.fire({
                        text: res.errorMsg || 'Something went wrong. Please try again',
                        confirmButtonText: `OK`,
                        icon: 'error'
                    });
                } else {
                    console.log('res...........', res)
                    setSuccessMsg(true);
                    setTimeout(() => {
                        setSuccessMsg(false);
                    }, 2000)
                    setTimeout(() => {
                        navigate("/customer_file_downloads");
                    }, 1500)
                    console.log('res', res);
                }

            }).catch(error => {
                Swal.fire({
                    text: 'Something went wrong. Please try again',
                    confirmButtonText: `OK`,
                    icon: 'error'
                });
                console.log('Error Upload', error, error.body);
            }).finally(() => {
                setShowLoader(false);
                setSaveButtonDisabled(true);
            })

    }

    const handleFileUpload = (e) => {
        const allowedExtensions = ['docx', 'doc', 'pdf', 'xlsx', 'xls', 'csv', 'png', 'jpg', 'jpeg'];
        const maxSizeInBytes = 10 * 1024 * 1024;

        const file = e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);

        if (file === null ||
            typeof (file) === 'undefined' ||
            file === '' ||
            typeof (file) === undefined ||
            !file ||
            !allowedExtensions.includes(fileType)
        ) {
            Swal.fire({
                text: 'Please choose a valid file.',
                confirmButtonText: `OK`,
                icon: 'error'
            });
            e.target.value = '';
            return;
        }

        if (file.size > maxSizeInBytes) {
            Swal.fire({
                text: 'File size should not be greater than 10MB.',
                confirmButtonText: `OK`,
                icon: 'error'
            });
            e.target.value = '';
            return;
        };

        if (file) {
            setFileUploaded(file);
        };
    }

    const handleFile = e => {
        let file = null;
        file = e.target.files[0];
        const fileType = file.name.substring(file.name.lastIndexOf('.') + 1, file.name.length);
        if (file === null || typeof (file) === 'undefined' || file === '' || typeof (file) === undefined || fileType.toLowerCase() !== 'csv') {
            Swal.fire({
                text: 'Please choose a valid .csv file.',
                confirmButtonText: `OK`,
                icon: 'error'
            });
            file = null;
            e.target.value = '';
            console.log('bad file');
        } else {
            console.log([e.target.name], e.target.files[0]);
            setUnregisteredRetailers([]);
            setPasrsedSimilarDataLength(0);
            setPasrsedDifferentDataLength(0);

            Papa.parse(file, {
                header: true,
                skipEmptyLines: true,
                complete: (results) => {
                    const checkValidHeader = Object.keys(results.data[0]);
                    if (checkValidHeader.includes('COMPANYNAME') && checkValidHeader.includes('SAPID')) {
                        const parseddata = permissions.permissions === 'isSap' ?
                            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + '-0000' + item.SAPID, label: item.COMPANYNAME + '-0000' + item.SAPID, sap: '0000' + item.SAPID.trim() })) :
                            results.data.map((item, i) => ({ id: i, value: item.COMPANYNAME + ' ' + item.SAPID, label: item.COMPANYNAME + ' ' + item.SAPID, sap: item.SAPID.trim() }));
                        console.log(parseddata);
                        let pasrsedSimilarData = [];
                        pasrsedSimilarData = originalList.filter(a1 => parseddata.some(a2 => a1.sap === a2.sap));
                        if (pasrsedSimilarData && pasrsedSimilarData.length) {
                            const similarArray = saleOffList !== null ? saleOffList.filter(({ sap: id1 }) =>
                                !pasrsedSimilarData.some(({ sap: id2 }) => id2 === id1)) : [];
                            setSaleOffList([...similarArray, ...pasrsedSimilarData]);
                            setPasrsedSimilarDataLength(pasrsedSimilarData.length);
                        }
                        const pasrsedDifferentData = parseddata.filter(a1 => pasrsedSimilarData.every(a2 => a1.sap !== a2.sap));
                        if (pasrsedDifferentData && pasrsedDifferentData.length) {
                            console.log(pasrsedDifferentData, pasrsedDifferentData.length)
                            setUnregisteredRetailers([...pasrsedDifferentData])
                            setPasrsedDifferentDataLength(pasrsedDifferentData.length);
                        }
                        setParsedCSVdata([...parseddata])
                    } else {
                        file = null;
                        Swal.fire({
                            text: 'File headers do not match. Kindly download and refer the sample file.',
                            confirmButtonText: `OK`,
                            icon: 'error'
                        });
                    }
                }
            });
        }
    }

    const cancelClick = () => {
        setSaleOffList([]);
        setSaleOffNameSapCode(originalList);
        setUnregisteredRetailers([]);
        setPasrsedSimilarDataLength(0);
        setPasrsedDifferentDataLength(0);
    }

    const cancelSalesClick = () => {
        setSaleOffList([]);
        setSaleOffNameSapCode(originalList);
        setSoSapCodeList(originalSOList);
        setSoList([]);
        setIsSoListPresent(false);
    }

    const cancelRegionClick = () => {
        setSaleOffList([]);
        setSaleOffNameSapCode(originalList);
        setRegionList([]);
        setRegionSapCodeList(originalRegionList)
        setIsRegionListPresent(false);
    }

    const cancelCustomerGroupClick = () => {
        setSaleOffList([]);
        setSaleOffNameSapCode(originalList);
        setCustomerGroupList([]);
        setCustomerGroupSapCodeList(originalCustomerGroupList)
        setIscustomerGroupListPresent(false);
    }

    const toggleUnregisteredRetailers = () => {
        setUnregisteredRetailersToggle(!unregisteredRetailersToggle)
    }

    return (
        <div>
            <div className="so-form-container so-form-container-rh" style={{ marginTop: 15 }}>
                <div className="so-form" style={{ paddingBottom: 10, paddingTop: 10 }}>

                    <div className="so-input" >
                        <label>Name<sup className="asterisk">*</sup></label>
                        <input
                            className="form-control"
                            type="text"
                            name="Title"
                            value={inAppTitle || ''}
                            onChange={titleChange}
                            style={{ marginBottom: 0 }}
                        />
                        {validationTitleError &&
                            <p className="so-input-error" >Please enter a name</p>
                        }
                    </div>

                    <div className="csv-file-upload-container target-upload-container" style={{ marginTop: 0, paddingBottom: 0 }}>
                        <Typography variant="subtitle2" mt={0} mb={1}><strong>Upload File :</strong></Typography>
                        <input
                            type="file"
                            id="file"
                            onChange={handleFileUpload}
                            accept=".docx,application/vnd.openxmlformats-officedocument.wordprocessingml.document,
                            .doc,application/msword,
                            .pdf,application/pdf,
                            .xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet,
                            .xls,application/vnd.ms-excel,
                            .csv,text/csv,
                            .png,image/png,
                            .jpg,image/jpeg,
                            .jpeg,image/jpeg"
                        />
                        <Box sx={{ mt: 3 }}>
                            <Typography variant="subtitle2"><strong>Instructions :</strong></Typography>
                            <ul style={{ paddingLeft: '20px', marginTop: '4px' }}>
                                <li>Allowed file types:  DOCX, DOC, PDF, XLSX, XLS, CSV, PNG, JPG, JPEG</li>
                                <li>Max file size (total): 10 MB</li>
                                <li>Please wait till files are uploaded as closing the browser during upload will make the file upload process fail.</li>
                                <li>Uploaded files may take up to 5 minutes to appear depending on the size.</li>
                            </ul>
                        </Box>
                    </div>

                    <div className="so-input" style={{ paddingTop: 0, paddingBottom: 0 }}>
                        {/* <label>Notification Send To<sup className="asterisk">*</sup></label> */}
                        <Typography variant="subtitle2" mt={2} mb={1}><strong>Notification Send To</strong> <sup className="asterisk">*</sup></Typography>
                        <select className="inapp-notification-sendto" name="type" value={type} onChange={selectHandleChange}>
                            <option value="Country">All Retailers</option>
                            <option value="Business">A set of Retailers</option>
                        </select>
                    </div>

                    {
                        type === 'Sales' &&
                        <React.Fragment>
                            <label className="select-label">Choose Sales Officer<sup className="asterisk">*</sup> (Atleast select one sales officer)</label>
                            <div className="select-retailer">
                                <Select
                                    value={soList}
                                    onChange={soHandleChange}
                                    options={soSapCodeList}
                                    isMulti
                                />
                                <button onClick={cancelSalesClick}>Clear</button>
                            </div>
                        </React.Fragment>
                    }

                    {
                        type === 'Sales' && isSoListPresent &&
                        <React.Fragment>
                            <label className="select-label">Choose  Retailer<sup className="asterisk">*</sup> (Atleast select one retailer)</label>
                            <div className="select-retailer">
                                <Select
                                    onChange={soRetailHandleChange}
                                    value={saleOffList}
                                    options={saleOffNameSapCode}
                                    isMulti
                                />
                                <button onClick={cancelSalesClick}>Clear</button>
                            </div>
                        </React.Fragment>
                    }

                    {
                        type === 'Region' &&
                        <React.Fragment>
                            <label className="select-label">Choose Region<sup className="asterisk">*</sup> (Atleast select one Region)</label>
                            <div className="select-retailer">
                                <Select
                                    value={regionList}
                                    onChange={regionHandleChange}
                                    options={regionSapCodeList}
                                    isMulti
                                />
                                <button onClick={cancelRegionClick}>Clear</button>
                            </div>
                        </React.Fragment>
                    }

                    {
                        type === 'Region' && isRegionListPresent &&
                        <React.Fragment>
                            <label className="select-label">Choose  Retailer<sup className="asterisk">*</sup> (Atleast select one retailer)</label>
                            <div className="select-retailer">
                                <Select
                                    onChange={regionRetailHandleChange}
                                    value={saleOffList}
                                    options={saleOffNameSapCode}
                                    isMulti
                                />
                                <button onClick={cancelRegionClick}>Clear</button>
                            </div>
                        </React.Fragment>
                    }

                    {
                        type === 'customerGroup' &&
                        <React.Fragment>
                            <label className="select-label">Choose Customer Group<sup className="asterisk">*</sup> (Atleast select one Group)</label>
                            <div className="select-retailer">
                                <Select
                                    value={customerGroupList}
                                    onChange={customerGroupHandleChange}
                                    options={customerGroupSapCodeList}
                                    isMulti
                                />
                                <button onClick={cancelCustomerGroupClick}>Clear</button>
                            </div>
                        </React.Fragment>
                    }

                    {
                        type === 'customerGroup' && iscustomerGroupListPresent &&
                        <React.Fragment>
                            <label className="select-label">Choose Customer Retailer<sup className="asterisk">*</sup> (Atleast select one Retailer)</label>
                            <div className="select-retailer">
                                <Select
                                    onChange={customerRetailerHandleChange}
                                    value={saleOffList}
                                    options={saleOffNameSapCode}
                                    isMulti
                                />
                                <button onClick={cancelCustomerGroupClick}>Clear</button>
                            </div>
                        </React.Fragment>
                    }


                    {
                        type === 'Business' &&
                        <div>
                            <div className="csv-file-upload-container target-upload-container">
                                {/* <label>Upload File</label> */}
                                <Typography variant="subtitle2" mt={0} mb={1}><strong>Upload File :</strong></Typography>
                                <input type="file" id="file" accept=".csv" onChange={handleFile} />
                                <div className="valid-file-upload">
                                    {/* <p>Instructions :</p> */}
                                    <Typography variant="subtitle2" mt={2} mb={1}><strong>Instructions File :</strong></Typography>
                                    <ul>
                                        <li>Only CSV files are allowed with Comma as separator.</li>
                                    </ul>
                                </div>
                                <div className="upload-file-format-download">
                                    <p>To get upload file format. <a
                                        href="https://navendor-global-production.s3-eu-west-1.amazonaws.com/infographics/sample.csv"
                                        target="_blank">Click here</a> to download</p>
                                </div>
                            </div>

                            {
                                pasrsedSimilarDataLength > 0 ||
                                    pasrsedDifferentDataLength > 0 ?
                                    <div className="csv-result-container">
                                        <label>CSV Result</label>
                                        <div className="csv-result">
                                            <div>
                                                <p onClick={toggleUnregisteredRetailers}>
                                                    {pasrsedSimilarDataLength} retailers found, {pasrsedDifferentDataLength} retailers unregistered.
                                                    {pasrsedDifferentDataLength > 0 ? ' Click to view unregistererd retailers' : ''}
                                                    {
                                                        pasrsedDifferentDataLength > 0 ?
                                                            <span className={unregisteredRetailersToggle ? `icon-arrow_down` : `icon-arrow_up`} />
                                                            : ''
                                                    }
                                                </p>
                                                {
                                                    pasrsedDifferentDataLength > 0 ?
                                                        <div className={unregisteredRetailersToggle ? `hide-unregistered` : `show-unregistered`}>
                                                            <React.Fragment>
                                                                {
                                                                    unregisteredRetailers.map(item => (
                                                                        <p key={item.id}>{item.label}</p>
                                                                    ))
                                                                }
                                                            </React.Fragment>
                                                        </div>
                                                        : ''
                                                }
                                            </div>
                                        </div>
                                    </div> :
                                    ''
                            }

                            <label className="select-label">Choose Retailers<sup className="asterisk">*</sup> (Atleast select one retailer)</label>
                            <div className="select-retailer" style={{ marginBottom: 0 }}>
                                <Select
                                    value={saleOffList}
                                    onChange={handleChange}
                                    options={saleOffNameSapCode}
                                    isMulti
                                />
                                <button onClick={cancelClick}>Clear</button>
                            </div>

                        </div>
                    }
                </div>

                {saveButtonDisabled &&
                    <div className="so-save-button">
                        <button
                            style={{ color: '#FFF', fontWeight: '700', letterSpacing: 0.5 }}
                            className={(!inAppTitle
                                || validationTitleError || (type === 'Business' && !saleOffList)) || !fileUploaded ? 'disable-save' : ''}
                            disabled={validationTitleError
                                || !inAppTitle || (type === 'Business' && !saleOffList) || !fileUploaded}
                            onClick={() => formSave()}>Save</button>
                    </div>
                }

                {showLoader && <div className="save-loader" />}
                {successMsg && <div className="so-updated" >Successfully Created </div>}
                {errorMsg && <div className="so-email-exist">{errorMsgText}</div>}
            </div>
        </div>
    )
}

export default UploadFile;